import React, { useContext, useEffect, useState } from "react";
import { Post } from "../../api/server";
import GlobalContext from "../../contexts/store";
import { toast } from "react-toastify";

export default function ContactForm() {
  const { company } = useContext(GlobalContext);
  const [values, setValues] = useState({
    name: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);

  const resetForm = () => {
    setValues({
      name: "",
      lastName: "",
      email: "",
      subject: "",
      message: "",
    });
  };

  const inputs = [
    {
      id: 1,
      name: "name",
      type: "text",
      label: "Your Name",
      placeholder: "Your Name",
      size: "6",
      errorMessage: "Please input your name",
      required: true,
    },
    {
      id: 3,
      name: "phone",
      type: "phone",
      label: "Phone",
      placeholder: "Phone",
      size: "6",
      errorMessage:
        "Please input your phone number so we can get incontact with you.",
      required: true,
    },
    {
      id: 4,
      name: "email",
      type: "email",
      label: "Email",
      placeholder: "Email",
      size: "6",
      errorMessage: "Please input your email",
      required: true,
    },
    {
      id: 5,
      name: "subject",
      type: "text",
      label: "Subject",
      placeholder: "Subject",
      size: "6",
    },
    {
      id: 6,
      name: "message",
      type: "textarea",
      label: "Message",
      placeholder: "Tell us about your project",
      size: "12",
      errorMessage:
        "Please tell us about your project so we can better understand",
      required: true,
    },
  ];

  const notify = (data, type) => {
    toast(data, {
      type: type || "default",
      theme: "dark",
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const trimmedName = values.name.trim();
    const trimmedLastName = values.lastName.trim();
    const trimmedEmail = values.email.trim();
    const trimmedSubject = values.subject.trim();
    const trimmedMessage = values.message.trim();

    if (!trimmedName) {
      notify("Please enter your name", "error");
      return;
    }
    if (!trimmedLastName) {
      notify("Please enter your last name", "error");
      return;
    }
    if (!trimmedEmail) {
      notify("Please enter your email", "error");
      return;
    }
    if (!trimmedSubject) {
      notify("Please enter your subject", "error");
      return;
    }
    if (!trimmedMessage || trimmedMessage.length < 10) {
      notify("Please enter your message, it must be at least 10 characters", "error");
      return;
    }


    Post("/contacts", {
      first_name: trimmedName,
      last_name: trimmedLastName,
      email: trimmedEmail,
      subject: trimmedSubject,
      message: trimmedMessage,
      company: company?._id,
    })
      .then(() => {
        resetForm();
        notify("Your message has been sent!", "success");
      })
      .catch((error) => {
        notify("Please try again later", "error");
      });
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  return (
    <div className="bg-transparent text-white text-base font-medium font-[16px] p-4 md:p-16">
      <h1 className="text-[40px] font-bold tracking-tight md:text-[56px]">
        Get in touch
      </h1>
      <form onSubmit={handleSubmit} className="mt-[32px] space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* First Name */}
          <div>
            <label htmlFor="name" className="mb-1 block text-sm text-white/70">
              First Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={values.name}
              onChange={onChange}
              className="mt-1 block h-11 w-full rounded-lg border-[0.5px] border-white/10 bg-white/5 px-3 text-white outline-none transition-colors focus:border-brand-blue focus:ring-1 focus:ring-brand-blue"
            />
          </div>

          {/* Last Name */}
          <div>
            <label htmlFor="lastName" className="mb-1 block text-sm text-white/70">
              Last Name
            </label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={values.lastName}
              onChange={onChange}
              className="mt-1 block h-11 w-full rounded-lg border-[0.5px] border-white/10 bg-white/5 px-3 text-white outline-none transition-colors focus:border-brand-blue focus:ring-1 focus:ring-brand-blue"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Email */}
          <div>
            <label htmlFor="email" className="mb-1 block text-sm text-white/70">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={values.email}
              onChange={onChange}
              className="mt-1 block h-11 w-full rounded-lg border-[0.5px] border-white/10 bg-white/5 px-3 text-white outline-none transition-colors focus:border-brand-blue focus:ring-1 focus:ring-brand-blue"
            />
          </div>
          {/* Subject */}
          <div>
            <label htmlFor="subject" className="mb-1 block text-sm text-white/70">
              Subject
            </label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={values.subject}
              onChange={onChange}
              className="mt-1 block h-11 w-full rounded-lg border-[0.5px] border-white/10 bg-white/5 px-3 text-white outline-none transition-colors focus:border-brand-blue focus:ring-1 focus:ring-brand-blue"
            />
          </div>
        </div>

        {/* Message */}
        <div>
          <label htmlFor="message" className="mb-1 block text-sm text-white/70">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            value={values.message}
            onChange={onChange}
            rows="4"
            className="mt-1 block h-32 w-full rounded-lg border-[0.5px] border-white/10 bg-white/5 px-3 py-2 text-white outline-none transition-colors focus:border-brand-blue focus:ring-1 focus:ring-brand-blue"
          ></textarea>
        </div>

        {/* Submit Button */}
        <div>
          <button
            type="submit"
            className="flex h-11 min-w-[160px] items-center justify-center rounded-lg bg-brand-blue px-8 font-semibold text-white transition-colors hover:bg-brand-blue-hover"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}
